import { useNavigate } from '@tanstack/react-router'
import { Button } from '@bpinternal/ui-kit-next'
import { Announcement } from '../types'

type AnnouncementDialogProps = {
  close: () => void
  announcement: Announcement
  workspaceId: string
  botId: string
}

export const AnnouncementDialog = ({ close, announcement, workspaceId, botId }: AnnouncementDialogProps) => {
  const navigate = useNavigate()

  return (
    <>
      <img src={announcement.asset} className="mb-3 h-full w-full overflow-hidden object-cover sm:rounded-t-lg"></img>
      <div className="flex flex-col justify-center gap-8 space-y-2 rounded-b-lg bg-neutral-50 p-6">
        <div className="flex flex-col gap-2">
          <p className="text-lg font-semibold text-neutral-950">{announcement.title}</p>
          <p className="text-sm text-neutral-950">{announcement.description}</p>
          <p className="text-sm text-muted-foreground">{announcement.instructions}</p>
        </div>
        <div className="flex justify-end gap-3">
          <Button variant="ghost" className="text-neutral-950" onClick={close}>
            {announcement.cancelLabel}
          </Button>

          <Button
            onClick={() => {
              close()
              navigate({
                to: announcement.navigateTo,
                params: { workspaceId, botId },
                search: () => announcement.navigateSearch,
              })
            }}
          >
            {announcement.confirmLabel}
          </Button>
        </div>
      </div>
    </>
  )
}
